<template>
<v-card width="100%" height="100%" color="#50505050">
    <v-container fluid width=100% fill-height>
        <v-layout align-center justify-center>
            <v-flex shrink>
                <v-progress-circular indeterminate color="white"></v-progress-circular>
            </v-flex>
        </v-layout>
    </v-container>
</v-card>
</template>
<script>
export default {
    name: "Loader"
}
</script>